import React from 'react';
import PromotionalLinkCopy from './components/ModalPromotionalLinkEducation/PromotionalLinkCopy';
import { useDetailDataStore } from '@/hooks/useDetailDataStore';
import { useTranslation } from 'react-i18next';
import {
  getCreatorPromotionalSettings,
  hasConfirmedCreatorPromotionalDetails,
  isCreatorPromotionalMode,
  readCreatorPromotionalDetails
} from '@/biz/creatorPromotionalDetails';

export default function RequirementPromotionalText() {
  const { t } = useTranslation();
  const { detailData } = useDetailDataStore();
  const utmLink = detailData?.order?.utmLink;
  const settings = getCreatorPromotionalSettings(
    detailData?.order,
    detailData?.campaign
  );
  if (isCreatorPromotionalMode(settings)) {
    const details = readCreatorPromotionalDetails(
      detailData?.order?.promotionalDetails
    );
    const confirmed = hasConfirmedCreatorPromotionalDetails(settings, details);
    return (
      <div className="w-full text-sm leading-snug">
        <span>
          {t(
            confirmed
              ? 'creator_promotional_details.confirmed_instructions'
              : 'creator_promotional_details.confirmation_required'
          )}
        </span>
        {confirmed && details?.link && (
          <PromotionalLinkCopy utmLink={details.link} />
        )}
        {confirmed &&
          settings.promotionalCodeRequired !== false &&
          details?.code && <span key={details.code}>{details.code}</span>}
      </div>
    );
  }
  return (
    <div className="w-full">
      <span className="text-text-color-primary text-sm font-bold font-['Inter'] leading-snug">
        {!!utmLink
          ? t(
              'config.requirementPromotionalText.use_promotional_link_with_colon',
              {
                defaultValue: 'Use the promotional link: '
              }
            )
          : detailData?.campaign?.landingpageurlMode === 'manual'
            ? t(
                'config.requirementPromotionalText.use_promotional_link_provided_by_brand',
                {
                  defaultValue: 'Use the promotional link provided by brand '
                }
              )
            : t(
                'config.requirementPromotionalText.use_promotional_link_provided',
                {
                  defaultValue:
                    'Use the promotional link provided by AhaCreator '
                }
              )}
      </span>
      {!!utmLink && <PromotionalLinkCopy utmLink={utmLink} />}
      <span className="text-text-color-primary text-sm font-normal font-['Inter'] leading-snug">
        {t('config.requirementPromotionalText.not_official_link', {
          defaultValue: ', not the official website link or a redirected link.'
        })}
      </span>
    </div>
  );
}
